import { useQuery } from "@tanstack/react-query";
import { fetchMyOnboarding } from "../api/onboardingApi";

export const onboardingQueryKey = ["onboarding", "me"] as const;

/**
 * Server-side onboarding funnel state. This is the source of truth for how far the user got:
 * the wizard previously held everything in component state, so closing the tab lost the whole
 * flow. Both the wizard and the route guard read from here.
 */
export function useOnboardingState(enabled: boolean = true) {
  return useQuery({
    queryKey: onboardingQueryKey,
    queryFn: fetchMyOnboarding,
    enabled,
    // Onboarding state only changes through this client's own mutations, which invalidate
    // the key explicitly. Refetching on every window focus mid-wizard just adds flicker.
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
